if (!customElements.get('pair-with-popup')) {
  customElements.define('pair-with-popup', class PairWithPopup extends HTMLElement {
    constructor() {
      super();
      this.previouslyFocused = null;
      this.redirectOnClose = false;
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.addEventListener('click', this.handleClick);
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() { document.removeEventListener('keydown', this.handleKeydown); }

    show(offerTemplate, { redirectOnClose = false } = {}) {
      if (!offerTemplate) return;
      this.previouslyFocused = document.activeElement;
      this.redirectOnClose = redirectOnClose;
      this.innerHTML = offerTemplate.innerHTML;
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer?.classList.contains('active')) cartDrawer.close();
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pair-with-popup-open');
      const dialog = this.querySelector('[data-pair-with-dialog]');
      const closeButton = this.querySelector('[data-pair-with-close]');
      if (typeof trapFocus === 'function') trapFocus(dialog, closeButton);
      else closeButton?.focus();
    }

    close(redirect = true) {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pair-with-popup-open');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      this.innerHTML = '';
      this.previouslyFocused?.focus();
      if (redirect && this.redirectOnClose) window.location = window.routes.cart_url;
    }

    handleClick(event) {
      if (event.target === this || event.target.closest('[data-pair-with-close]')) {
        this.close();
        return;
      }
      const addButton = event.target.closest('[data-pair-with-add]');
      if (addButton) this.addPairedProduct(addButton);
    }

    handleKeydown(event) { if (event.key === 'Escape' && this.hasAttribute('open')) this.close(); }

    async addPairedProduct(button) {
      if (button.disabled) return;
      const errorElement = this.querySelector('[data-pair-with-error]');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const properties = {
        _upsell_source: 'pair_with_popup',
        _upsell_source_product: button.dataset.upsellSourceProduct,
        _upsell_rule_level: button.dataset.upsellSourceType,
      };
      if (button.dataset.upsellSourceCollection) {
        properties._upsell_rule_collection = button.dataset.upsellSourceCollection;
      }
      const payload = {
        items: [{ id: Number(button.dataset.variantId), quantity: 1, properties }],
      };
      if (cart) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }
      button.disabled = true;
      button.classList.add('is-loading');
      button.querySelector('.pair-with-popup__spinner')?.removeAttribute('hidden');
      errorElement?.setAttribute('hidden', '');
      try {
        const result = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        const response = await result.json();
        if (!result.ok || response.status) throw new Error(response.description || window.pairWithStrings.error);
        this.close(false);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pair-with-popup', productVariantId: button.dataset.variantId, cartData: response });
        if (cart) cart.renderContents(response);
        else window.location = window.routes.cart_url;
      } catch (error) {
        if (errorElement) {
          errorElement.textContent = error.message;
          errorElement.removeAttribute('hidden');
        }
        button.disabled = false;
        button.classList.remove('is-loading');
        button.querySelector('.pair-with-popup__spinner')?.setAttribute('hidden', '');
      }
    }
  });
}
